export default {
      id: "238_cm_=_100_+_35_+_100-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#238_cm_=_100_+_35_+_100",
      toString: function () {
        return this.url;
      }
    }